// removed by extract-text-webpack-plugin
module.exports = {"block":"_1aP6ECcZGORX9K-_ZTLYUU","header":"l4meEJ1K-QC0SHNGgKPcH","content":"_2ZfDyOySI9JqwSVZXMOJJs","items":"_14ZLrgixZODS8-awtU1BEn","readMore":"_2MO6ihu7oEdLMYZYKP9oF_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BoardBlock/BoardBlock.module.scss
// module id = 735
// module chunks = 0